import { Component, OnInit, EventEmitter, Output, ElementRef, ViewChild, ChangeDetectorRef, TemplateRef, Input, SimpleChanges } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { FormGroup, FormControl,FormBuilder} from '@angular/forms';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CoreService } from '../../../services/coreService/core.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { AddCoreVm, CoreVm, FileModelVM } from 'src/app/viewModels/core/core-vm';
import * as jwt_decode from 'jwt-decode';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { map, startWith } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ConfirmDialogModel, ConfirmDialogComponent,} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AddTouchesComponent } from 'src/app/middleware/common/addtouches/addtouches.component';
import { ModuleName } from '../../../services/coreService/core.enum';

@Component({
  selector: 'app-listing-detail',
  templateUrl: './listing-detail.component.html',
  styleUrls: ['./listing-detail.component.scss'],
})
export class ListingDetailComponent implements OnInit {
  @Output() closeDetail = new EventEmitter<boolean>();

  chkStatusArry: any;
  coreFieldList: any;
  checkBoxList: any;
  currentUser: any;

  dynamicArray: any;
  dynamicArrayEdit: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;

  transactionUserName: any;
  ImagePathURL: string = '';
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  openDocumentDetail: boolean = false;
  showUserDetail: boolean = false;
  showContactList: boolean = false;
  showCreateTouches: boolean = false;
  showContactdetail: boolean = false;
  showShareFile: boolean = false;
  documentViewer: boolean = false;
  showCreateTask: boolean = false;
  showLinkPI: boolean = false;
  showTaskDetail: boolean = false;
  getFieldsListResponseHolder: any;
  fieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  dropdownlist: any;
  multipleDropdownList: any;
  radioButtonlist: any;  
  getFieldModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
  }; 

  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: false,
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  showTextBoxField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  clickEventsubscription: Subscription;
  coreUserList: any;
  responseHolder: any;
  transactionID: string;
  databaseId: string;
  organizationId: string;
  myFormGroup: FormGroup;
  myTouchesForm: FormGroup;
  TypeList: any = [];
  TypeListForDropDown: any = [];
  selectedTypeList: any;
  step = 0;
  TypeIdDrp:number=0;

  deleteCoreModel = {
    coreID: [],
    userID: '',
    databaseID: 0,
    organizationID: 0,    
    folderID:0
  };

  getTagListResponseHolder: any;
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,    
    PageSize:0
  };
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;
  CityModel = {
    Name: '',
    databaseID: 0,
    userID:''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID:''
  };
  zipOption: any[];
  stateList: any[];
  cityOption: string[]=[];

  tags: string[];
  allTags: string[] = [];
  TouchesType :any[]=[];
  AllCoreTouchesList  :any[]=[];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  transactionUserRole: any;
  arryaControlNameIdpare: any=[];
  addressFormGroup: any=[];
  cityValue: any;
  stateValue: any;
  zipValue: any;
  countryValue: any;
  emptyArrya: any=[];
  isTypeChanged: boolean=false;
  tagvalues: string;
  Module:string;
  folderList: any[] = [];
  modulename:string;
  folderId:number=0;
  OfficeIDList: any=[];
  myOfficeID: any;

  @Input() transactionId: number=0; 
  showPaycheck:boolean=false;
  
  constructor(private dialog: MatDialog, private formBuilder: FormBuilder,private statusConst: StatusConstant, 
    private loaderService: LoaderService,private coreService: CoreService, private toastr: ToastrService,   
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,  
    private _dataSharingService: DataSharingService, private coreVm: CoreVm, private addCoreVm: AddCoreVm,
    private fileModelVM: FileModelVM, private settingsService: SettingService, private cdr: ChangeDetectorRef,
    private router: Router) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken); 
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  // ngOnDestroy() {
  //   this.clickEventsubscription.unsubscribe();      
  // }

  ngOnChanges(changes: SimpleChanges) {
     this.Module= ModuleName.Core;
     this.dynamicArray = [];
     this.dynamicArrayPhone = [];
     this.dynamicArrayAddress = [];
     this.dynamicArrayWebsite = [];
     this.dynamicArrayAddressTemp = [];     
     let group = {};
     this.myFormGroup = new FormGroup(group);
     var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
     var Module=[];
     Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core && x.isAssign==true);
     if(Module.length>0){     
       this.folderId = Module[0].folderID;
       }      
      this.transactionID = (this.transactionId["transactionID"]).toString();
      this.TypeIdDrp = (this.transactionId["TypeID"]);
      sessionStorage.setItem('transactionID', this.transactionID);
      this.getAllTagsList();
      this.getStateDropdownList(231);
      //this.getCoreUserDetailsforSubFolderId();
      this.getCoreUserDetails();
  }


  ngOnInit(): void {   
     this.Module= ModuleName.Core;
    // this.dynamicArray = [];
    // this.dynamicArrayPhone = [];
    // this.dynamicArrayAddress = [];
    // this.dynamicArrayWebsite = [];
    // this.dynamicArrayAddressTemp = [];
    // this.getStateDropdownList(231);
    // let group = {};
    // this.myFormGroup = new FormGroup(group);
    // this.clickEventsubscription = this._dataSharingService.getCore1User().subscribe((result) => {
    //     if (result !== '') {        
    //       var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    //       var Module=[];
    //       Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    //       if(Module.length>0){     
    //         this.folderId = Module[0].folderID;
    //        }      
    //       this.transactionID = result;         
    //       sessionStorage.setItem('transactionID', this.transactionID);
    //       this.getCoreUserDetailsforSubFolderId();            
    //       this.getAllTagsList();
    //      // this.getAllTouchesList();      
    //     }
    //   });          
    //  this.getTouchTypeList();   
  }

  onTabClick(event) {
    if(event.tab.textLabel=="Activity" || event.index==1){
      this.AllCoreTouchesList = [];
      this.getAllTouchesList();
    }    
  }
  
  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }
  
  nextStep() {
    this.step++;
  }
  
  prevStep() {
    this.step--;
  }

  editTouch(touch:any){
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:ModuleName.Core,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        touch:touch
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.getAllTouchesList();
      }      
    });
  }
  deleteTouch(touch:any){
    const message = `Are you sure you want to delete this activity ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let model={
            "touchesID": [
              touch.touchID
            ],
              transactionID:Number(sessionStorage.getItem('transactionID')),
              databaseId:Number(this.databaseId),
              organizationID:Number(this.organizationId),
              userID:this.currentUser.UID,
              officeID: this.myOfficeID
          }
          this.coreService.DeleteCoreTouch(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) { 
                this.getAllTouchesList();
                this.toastr.success("Deleted successfully.", '', {
                  timeOut: 3000,
                });  
              }
              else {
               
              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });     
  }
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();

    this.allTags;
    var check=[];
    check= this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if(check.length>0){
     this.fruitCtrl.setValue(null);
     return;
    }   

    // Add our Tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {        
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
    this.myFormGroup.markAsDirty();	
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags =  this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  // get Tag List
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.allTags = this.getTagListResponseHolder.data.tagNames;      
        }
        else {
        }
      }
    });
  }

  
  isChecked(fieldName, chk) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    if (_newcheckBoxlist[0].selectedCHK != '') {
      return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
    } else {
      return false;
    }
  }

  // OnChange($event: any, chk: any, fieldId: any) {
  //   this.myFormGroup.get(chk).markAsDirty();    
  //   if (!this.chkStatusArry) {
  //     this.chkStatusArry = [];
  //   }
  //   if ($event.checked) {
  //     this.chkStatusArry.push({
  //       ckh: chk,
  //       fieldId: fieldId,
  //     });
  //   } else {
  //     if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
  //       this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
  //     }
  //   }
  // }


   OnChange($event: any, chk: any, fieldId: any) {
    this.myFormGroup.get(chk).markAsDirty();
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {     
      if(this.chkStatusArry.length>0){
       var checkRecord=[];
       checkRecord = this.chkStatusArry.filter(x=>x.fieldId==fieldId);
       if(checkRecord.length>0){
       this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = chk;
       }
      }else{
       this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
       });
      }    
    } else {
      if(this.chkStatusArry.length>0){
        this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = '';
      } 
      // if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
      //   this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
      // }
    }
  }
  
  getddlSelectedVal(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '') {
        return _newdropdownlist[0].selectedVal;
      } else {
        return '';
      }
    }
  }

  getMultiddlSelectedVal(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '') {
        if(fieldName!="Tags"){         
          return _newMuldropdownlist[0].selectedVal.split(',');
        }else{
          return _newMuldropdownlist[0].selectedVal;
        }
      } else {
        return '';
      }
    }
  }


  getCheckBoxlist(fieldName) {
    if (this.checkBoxList) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
        if(_newcheckBoxlist[0]){
        _newcheckBoxlist[0].value.forEach(v => {
          this.myFormGroup.addControl(v, this.formBuilder.control(''));    
        });  
        return _newcheckBoxlist[0].value;
      }
    }
  }

  getdropdownlist(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if(_newdropdownlist.length>0)
      return _newdropdownlist[0].value;
      else
      "";
    }
  }

  getMuldropdownlist(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if(_newMuldropdownlist.length>0)
      return _newMuldropdownlist[0].value;
      else
      "";
    }
  }
  

  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');      
    }
  }

   prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
     this.chkStatusArry=[];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(',');
        var selectedVal;
        let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

        if (chk.length > 0) {
          selectedVal = chk[0].fieldValue;
          selectedVal= selectedVal.replace(/,/g, '');
        }
        else {
          selectedVal = this.checkBoxList[i].fieldValue;
          selectedVal= selectedVal.replace(/,/g, '');
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }
        
        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };

        fieldcheckbox.push(FieldsCheckbox);

        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }

  // prepareCheckboxListForUI() {
  //   if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
  //     var fieldcheckbox = [];
  //     var value;
  //     if (!this.chkStatusArry) {
  //       this.chkStatusArry = [];
  //     }
  //     for (let i = 0; i < this.checkBoxList.length; i++) {       
  //       var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
  //       value = checkboxValue.split(','); 
  //       var selectedVal;
  //       let chk=this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);
  //       if(chk.length>0){
  //         selectedVal=chk[0].fieldValue;
  //       }
  //      else{
  //       selectedVal=this.checkBoxList[i].fieldValue
  //      }        
        
  //      if(selectedVal==undefined || selectedVal==null){
  //       selectedVal="";
  //     }

  //     //  if(chk.length==0){
  //     //   selectedVal="";
  //     //  } 

  //       var FieldsCheckbox = {
  //         FieldValue: this.checkBoxList[i].fieldName,
  //         value: value,
  //         selectedCHK: selectedVal//this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
  //       };

  //       fieldcheckbox.push(FieldsCheckbox);

  //       let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
  //       for (let n = 0; n < selectedCHKArray.length; n++) {
  //         this.chkStatusArry.push({
  //           ckh: selectedCHKArray[n],
  //           fieldId: this.checkBoxList[i].fieldID,
  //         });
  //       }
  //     }
  //     this.checkBoxList = fieldcheckbox;
  //   }
  // }

  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }

  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp=this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if(drp.length>0){
          selectedVal=drp[0].fieldValue;
        }
        else{
         selectedVal=this.multipleDropdownList[i].fieldValue
       }
       if(selectedVal==undefined || selectedVal==null){
        selectedVal="";
      }
      //  if(drp.length==0){
      //   selectedVal="";
      //   }  
        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal:selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }

  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }
  
  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {
        if(this.dropdownlist[i].defaultValue.length > 0)  {
          var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
          value = drpValue.split(',');
          var selectedVal;
         let drp=this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
         if(drp.length>0){
           selectedVal=drp[0].fieldValue;
         }
         else{
          selectedVal=this.dropdownlist[i].fieldValue;
        }
        
        if(selectedVal==undefined || selectedVal==null){
          selectedVal="";
        }

        if(this.dropdownlist[i].fieldName=="Status"){
          selectedVal = this.statusType;
        }

         var FieldsDrp = {
          FieldValue: this.dropdownlist[i].fieldName,
          value: value,
          selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
        };
        fieldListdrp.push(FieldsDrp);
       }
      }
      this.dropdownlist = fieldListdrp;      
    }
  }
  


  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  appendEle(field: any, type: any,index:any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);
    let addressRefactor = field.address.filter(function(value, index) { return index != 3;});
        addressRefactor.splice(2,0,field.address.find(x=>x.childFieldType==3));

    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address:addressRefactor
    };
    //1 Email ,2 Address,3 Phone,4 website
     //1 Email ,2 Address,3 Phone,4 website
     if(type==2){
       //
       this.myFormGroup.addControl('City' + index,this.formBuilder.control(''));
       this.myFormGroup.addControl('State' + index,this.formBuilder.control(''));
       this.myFormGroup.addControl('ZipCode' + index,this.formBuilder.control(''));
       this.myFormGroup.addControl('Country' + index,this.formBuilder.control(''));
 
       // address array for computation
       this.addressFormGroup.push('Address'+ index);
       this.addressFormGroup.push('City'+ index);
       this.addressFormGroup.push('State'+ index);
       this.addressFormGroup.push('ZipCode'+ index);
       this.addressFormGroup.push('Country'+ index);
       //
     }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);    
  }

  
  addMore(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });
      //
      this.myFormGroup.addControl('City' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length,this.formBuilder.control(''));
      //

      // address array for computation
      this.addressFormGroup.push('Address'+ length);
      this.addressFormGroup.push('City'+ length);
      this.addressFormGroup.push('State'+ length);
      this.addressFormGroup.push('ZipCode'+ length);
      this.addressFormGroup.push('Country'+ length);
      //

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address:this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option',this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }
  
  // getCoreUserDetailsforSubFolderId() {
  //   this.coreUserList = [];   
  //   this.coreVm.DatabaseID = Number(this.databaseId);
  //   this.coreVm.OrganizationID = Number(this.organizationId);
  //   this.coreVm.coreID = Number(sessionStorage.getItem('transactionID'));

  //   if (Number.isNaN(this.coreVm.coreID)){
  //     return;
  //   }
  //   if(this.coreVm.coreID == 0){
  //     return;
  //   }
  //   this.coreVm.FolderId = this.folderId;//17;//this.transactionID; 
  //   this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConst.statusSuccess) {
                   
  //         var TypeData =  response.data.fields.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

  //         if (TypeData.length > 0 && TypeData !=undefined) {            
  //           if(TypeData[0].fieldValue != ""){
  //             let id: string = TypeData[0].fieldValue.toString();
  //             this.TypeIdDrp = parseInt(id);             
  //           }
  //           else {              
  //             this.TypeIdDrp=0;
  //           }           
  //         }
  //         else{
  //           this.TypeIdDrp=0;
  //         } 
  //         this.getCoreUserDetails();
  //       }
  //     }         
      
  //   });
  // }


  getCoreUserDetailsOnTypeChange(event:any,fieldName:any){
    this.isTypeChanged=true;
    this.TypeIdDrp = parseInt(event.value);   
    this.arryaControlNameIdpare=[];
    this.getCoreUserDetails();
  }

  statusType:string="";
  convertToUTCDate(dateString: string): Date | string {
    if (!dateString) return '';
    // Split the date and time parts by 'T'
    const [datePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number)
    const date= new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
    //let newUTCDate=this.formatAsUTC(date); 
    return date;
  }
  
  getCoreUserDetails() {  
    //this.coreUserList = [];
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.coreID = Number( sessionStorage.getItem('transactionID'));
    this.coreVm.FolderId = this.folderId;//17;//this.transactionID; 
    this.coreVm.subFolderID =Number(this.TypeIdDrp);  //37; 
    this.coreVm.officeID=this.myOfficeID;
    this.coreVm.OfficeIDList=this.OfficeIDList;
    this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.statusType =response.data.status;
          this.coreUserList = response.data.fields;
          this.TypeListForDropDown =response.data.types;
          if(this.responseHolder.data.paychexID==null){
            this.showPaycheck=false;
          }else{
            this.showPaycheck=true;
          }
          this.TypeListForDropDown.splice(0,0,{folderName: "Select",isChecked: false,subFolderID: 0});         

          var taglist;

          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist !=undefined) {
            this.tags = [];
            if(taglist[0].fieldValue != ""){
              this.tags= taglist[0].fieldValue.split(',');
            }
            else{
              this.tags=[];
            }           
          }
          else{
            this.tags=[];
          }                

          var NewList;
          NewList = response.data.fields.filter((s) => s.fieldName != 'Type' );
          var type;
          type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');         
         
          NewList.splice(1, 0, type[0]);
          this.coreUserList = NewList;

          this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2); 
          this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);                           

          //Change name for dynamic elements
          // Group them one beneath othe for multi name array
          let multiNameArray = [];
          let ArrayWithGroupedElement = [];
          this.coreUserList.forEach((formControl) => {
            if(formControl.fieldTypeName=='Date')
              {
               formControl.fieldValue= this.convertToUTCDate(formControl.fieldValue);
              }
            let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
            if (count == 0){
                multiNameArray.push(formControl);
                 //  Save control name and ID
                this.arryaControlNameIdpare.push({
                  name:formControl.fieldName,
                  id:formControl.id,
                  subFolderID:formControl.subFolderID
                });
                if(formControl.fieldName.includes('Address'))
                {
                 formControl.address.forEach((ac,i) =>  {
                  if(i>0)
                   this.arryaControlNameIdpare.push({
                     name:this.getAddressTypeFieldName(ac.childFieldType),
                     id:ac.id,
                     subFolderID:ac.subFolderID
                   });
                 });
                }           
            }
           else if (count > 0)
            {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;

                 //  Save control name and ID
                this.arryaControlNameIdpare.push({
                  name:formControl.fieldName,
                  id:formControl.id,
                  subFolderID:formControl.subFolderID
                });
                if(formControl.fieldName.includes('Address'))
                {
                 formControl.address.forEach((ac,i) => {
                   if(i>0)
                   this.arryaControlNameIdpare.push({
                     name:this.getAddressTypeFieldName(ac.childFieldType)+count,
                     id:ac.id,
                     subFolderID:ac.subFolderID
                   });
                 });
                }           
              }
           });

          this.coreUserList.forEach((formControl) => {
            let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0).length;
            let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0);
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }
        
              ArrayWithGroupedElement.push(elements[0]);
            
            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });


          this.coreUserList = ArrayWithGroupedElement;
         
          const Fields = {};
          this.coreUserList.forEach((formControl) => {
            if (formControl.fieldName == 'Name') {
              this.transactionUserName = formControl.fieldValue;
            
            }
            
            if (formControl.fieldName == 'Type') {
              let type=this.TypeListForDropDown.find(x=>x.subFolderID==formControl.fieldValue);
              this.transactionUserRole = (type!=null ||type!=undefined)?type.folderName:""
            }
            
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find(
                (x) => x.fieldNameID == formControl.fieldNameID
              );
              formControl.placeholderVal=plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];           
            }
          });
          this.ImagePathURL = (response.data.imageUrl==null || response.data.imageUrl==undefined || response.data.imageUrl=='')?'':response.data.imageUrl;
          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
            // address computaion array for computation
         this.addressFormGroup.push('Address');
         this.addressFormGroup.push('City');
         this.addressFormGroup.push('State');
         this.addressFormGroup.push('ZipCode');
         this.addressFormGroup.push('Country');     
          
          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          var reqModel={
            userID : this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),     
            folderID : this.folderId,//17;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID:this.myOfficeID,
            OfficeIDList:this.OfficeIDList
          }           
          this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList=response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;

              // Modified array containing group starts
              tempArryacoreFieldList.forEach(element => {
                if(element.data.length>1){
                  var indexArray=[];
              
                  element.data.forEach(elementin => {
                    if(elementin.fieldID>0){
                      let grpele=this.coreUserList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                      elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
                      elementin.id=grpele!=undefined?grpele.id:0;
                      elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
                      if(elementin.fieldNames.length>0){
                      elementin.fieldNameID=grpele.fieldNameID;
                      elementin.placeholderVal=grpele.placeholderVal; 
                      }
                      this.coreFieldList.push(elementin);
                      if (!this.myFormGroup.contains(elementin.fieldName)){
                        this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                      }
                      var index = this.coreUserList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                      indexArray.push(index);
                    }
                  });
              
                  this.coreUserList = this.coreUserList.filter(function(value, index) { 
                    return indexArray.indexOf(index) == -1; 
                }) ;
                  this.coreUserList.splice(indexArray[0],0,element);                  
                }
              });
              ArrayWithGroupedElement.forEach(element => {
                if(element.fieldName=="Address"){
                  if(element.address.length>0){
                    if(element.address.find(m=>m.childFieldType==3)!=undefined)
                      this.cityValue=element.address.find(m=>m.childFieldType==3).fieldValue;
                      else
                      this.cityValue="";
                    if(element.address.find(m=>m.childFieldType==2)!=undefined)
                      this.stateValue=element.address.find(m=>m.childFieldType==2).fieldValue;
                      else
                      this.stateValue="";
                    if(element.address.find(m=>m.childFieldType==4)!=undefined)
                      this.zipValue=element.address.find(m=>m.childFieldType==4).fieldValue;
                      else
                      this.zipValue="";
                  }
                }
              });
              
              this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
              this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
              this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
                
              var data = [];

              data=this.coreUserList.filter((s) => s.fieldID ==0);
    
              if (data.length > 0) {
                for (var i = 0, len = data.length; i < len; ++i) {
                  var DrpData = [];
                  DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
                  if(DrpData.length>0){
                    for (var v = 0, char = DrpData.length; v < char; ++v) {
                      this.dropdownlist.push(DrpData[v]);
                    }
                  }
                 
                  var MultiData=[];
                  MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
                  if(MultiData.length>0){
                    for (var v = 0, char = MultiData.length; v < char; ++v) {
                      this.multipleDropdownList.push(MultiData[v]);
                    }
                  }
                  
                  var CheckboxData=[];
                  CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
                  if(CheckboxData.length>0){
                    for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                      this.checkBoxList.push(CheckboxData[v]);
                    }
                  }             
                }
              }               
    
                if (this.dropdownlist.length > 0) {
                  var fieldListdrp = [];
                  var value;
                  for (let i = 0; i < this.dropdownlist.length; i++) {                  
                    var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                    value = drpValue.split(',');
                    var FieldsDrp = {
                      FieldValue: this.dropdownlist[i].fieldName,
                      value: value,
                    };
                    fieldListdrp.push(FieldsDrp);
                  }
                  this.dropdownlist = fieldListdrp;
                }
    
                if (this.multipleDropdownList.length > 0) {
                  var fieldmulListdrp = [];
                  var value;
                  for (let i = 0; i < this.multipleDropdownList.length; i++) {
                    var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                    value = muldrpValue.split(',');
                    var FieldsMulDrp = {
                      FieldValue: this.multipleDropdownList[i].fieldName,
                      value: value,
                    };
                    fieldmulListdrp.push(FieldsMulDrp);
                  }
                  this.multipleDropdownList = fieldmulListdrp;
                }
    
                if (this.checkBoxList.length > 0) {
                  var fieldcheckbox = [];
                  var value;
                  for (let i = 0; i < this.checkBoxList.length; i++) {
                    var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                    value = checkboxValue.split(',');
                    var FieldsCheckbox = {
                      FieldValue: this.checkBoxList[i].fieldName,
                      value: value,
                    };
                    fieldcheckbox.push(FieldsCheckbox);
                  }
                  this.checkBoxList = fieldcheckbox;
                }   

              // Modified array containing group ends 
              this.fillCheckBoxList();
              this.prepareCheckboxListForUI();

              this.fillDropDown();
              this.prepareDropDownForUI();

              this.fillMultiDropDown();
              this.prepareMultiDropDownForUI();
            });
          this.dynamicArray = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayWebsite = [];
          this.dynamicArrayTemp.forEach((e,i) => {
            this.appendEle(e, 1,i+1);
          });
          this.dynamicArrayAddressTemp.forEach((e,i) => {
            this.appendEle(e, 2,i+1);
          });
          this.dynamicArrayPhoneTemp.forEach((e,i) => {
            this.appendEle(e, 3,i+1);
          });
          if (this.dynamicArrayWebsiteTemp != undefined)
            this.dynamicArrayWebsiteTemp.forEach((e,i) => {
              this.appendEle(e, 4,i+1);
            });
         
          if(this.isTypeChanged){
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged=false;
          }
        } else {
          this.coreUserList = [];
        }
      }
    });
  }

  getAddressTypeFieldName(childFieldType){
    if(childFieldType==3)
    return 'City';
    if(childFieldType==2)
    return 'State';
    if(childFieldType==4)
    return 'ZipCode';
    if(childFieldType==1)
    return 'Country';
  }

  getSubFolderFields(event, fieldName) {   
    if (event != undefined && fieldName == "Type") {
      this.TypeIdDrp =event.value;    
     }
  }
  
  getShortName(fullName) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.'); 
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
    this.myFormGroup.markAsDirty();	
    this.myFormGroup.markAsTouched();
    this.cdr.detectChanges;     
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.ImagePathURL = response.data;
          }
        }
      });
  }

  getStateDropdownList(countryId:any) {
    if (countryId!=undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
          if (response!=undefined) {
            if (response.status == this.statusConst.statusSuccess) {
              this.stateList = [];
              if(countryId == 231 || countryId == 38){               
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              } 
            }
          }
        });
    }
  }

  searchZip(zip :any){
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {        
          this.zipOption=[];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }


  searchCity(name :any){ 
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {          
          this.cityOption=[];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }


  SaveCoreUserDetails(formValues: any) {
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.CoreID = Number(this.transactionID);
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) =>key.includes(m.fieldName));
          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {           
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
             var selectedValueChk = this.chkStatusArry
              .filter((item) => item.fieldId == tempList[0].fieldID)
              .map((x) => x.ckh)
              .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();             

            } else {
                 selectedValues = '';
             }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }         

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let localDateOnly="";
          if(tempList[0].fieldTypeName=='Date')
          {
            let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;

            // If selectedDate is a string, set localDateOnly to the string value directly
            if (typeof selectedDate === "string") {
              localDateOnly = selectedDate;
            } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
              // Adjust the date to remove time and prevent timezone shift
              localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]; // Returns 'yyyy-MM-dd'
              formValues[key]= localDateOnly;
            } else {
              localDateOnly = ""; // Set to empty if no valid date
            }

          }
          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
                FieldNameID:
                tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID: frmctrl!=undefined? frmctrl.subFolderID:0,
                ChildFields: [],
                id:frmctrl!=undefined? frmctrl.id:0
          });
        }
      }
    
       /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
      let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
      var checkcity=[];
      checkcity= this.arryaControlNameIdpare.filter(e => e.name== 'City');
      if(checkcity.length>0){
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name== 'City').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["City"],
          "childFieldType": 3
        });
      }
      var checkstate=[];
      checkstate= this.arryaControlNameIdpare.filter(e => e.name== 'State');
      if(checkstate.length>0){
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name== 'State').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["State"],
          "childFieldType": 2
        });
      }
      var checkzip=[];
      checkzip= this.arryaControlNameIdpare.filter(e => e.name== 'ZipCode');
      if(checkzip.length>0){
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name== 'ZipCode').id,
        "fieldID":AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      });
      }
      var checkcountry=[];
      checkcountry= this.arryaControlNameIdpare.filter(e => e.name== 'Country');
      if(checkcountry.length>0){
      AddressDefault.ChildFields.push({
        "id": this.arryaControlNameIdpare.find(e => e.name== 'Country').id,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      });
      }
     fieldList = fieldList.filter(function(value, index) { 
        return index != indexDefault; 
    }) ;
    fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    

       //
       this.dynamicArrayAddress.forEach((element,i) => {
        i=i+1;
       let cityctrl= this.arryaControlNameIdpare.find(e => e.name== 'City'+i);
       let statectrl= this.arryaControlNameIdpare.find(e => e.name== 'State'+i);
       let zipcodectrl= this.arryaControlNameIdpare.find(e => e.name== 'ZipCode'+i);
       let countryctrl= this.arryaControlNameIdpare.find(e => e.name== 'Country'+i);
        let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
        let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
        if(AddressDynamic!=undefined)
        {
        AddressDynamic.ChildFields.push({
          "id": cityctrl!=undefined?cityctrl.id:0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City"+i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": statectrl!=undefined?statectrl.id:0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State"+i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": zipcodectrl!=undefined?zipcodectrl.id:0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode"+i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": countryctrl!=undefined?countryctrl.id:0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country"+i],
          "childFieldType": 1
        })

      fieldList = fieldList.filter(function(value, index) { 
          return index != indexDynamic; 
      }) ;
      fieldList.splice(indexDynamic,0,AddressDynamic);
       }
      });
      fieldList =fieldList.filter(x=> x.FieldName!="Status");
      //********** */
      //fieldList=fieldList.filter(x=>x.id!=0 && x.FieldValue!="");  
      this.addCoreVm.ImageUrl=this.ImagePathURL;
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.Tags=this.tagvalues;
      this.addCoreVm.officeID=this.myOfficeID;
      this.addCoreVm.OfficeIDList=this.OfficeIDList;
      this.addCoreVm.Status=formValues.Status;
      this.addCoreVm.TypeID=Number(this.TypeIdDrp)>0?Number(this.TypeIdDrp):0;
      this.loaderService.show();
      this.coreService.saveCoreUserDetails(this.addCoreVm).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {          
              this._dataSharingService.sendSaveUserForCore();  
              this.closeListingDetail(false);
              this.myFormGroup.markAsPristine();             
              this.arryaControlNameIdpare=[];              
              this.toastr.success('Record update successfully.', '', {
                timeOut: 3000,
              });
            }
          }else{
            this.loaderService.hide();
          }
        });
    }
  }

  


  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  closeListingDetail(message) {    
    this.showPaycheck=false;
    this.AllCoreTouchesList=[];
    this.closeDetail.emit(message);
    if(this.myFormGroup.dirty){
      this.myFormGroup.markAsPristine;
    }
  }

  openInDocument(){
    const id =  this.transactionID;
    sessionStorage.setItem('transactionID', id);
    sessionStorage.setItem('moduleName', ModuleName.Core)
    sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
    this.router.navigate(['/core/documents'], {});
    this._dataSharingService.sendNextPreviousDocumentFromCore(false);
    this._dataSharingService.sendNextPreviousForRightPanelFromCore(false);
    this._dataSharingService.sendNextPreviousForTouchesFromCore(false);
    // const id =  this.transactionID;    
    // var tagId = {
    //   Id: id,
    //   moduleName:  ModuleName.Core
    // };
    // sessionStorage.setItem('transactionID', id);   
    // sessionStorage.setItem('moduleName', ModuleName.Core);

    // this.router.navigate(['/core/documents'], {});
    // this._dataSharingService.sendSelectedCoreUser(tagId);    
  }

  CoreIdList: any = [];

  DeleteCore(){
    var id =  this.transactionID;    
    this.CoreIdList.push(id);

    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (id !== undefined) {
            this.deleteCoreModel.userID = this.currentUser.UID;
            this.deleteCoreModel.folderID = this.folderId;//17;//Number(folder.folderID);
            this.deleteCoreModel.databaseID = Number(this.databaseId);
            this.deleteCoreModel.organizationID = Number(this.organizationId);
            this.deleteCoreModel.coreID = this.CoreIdList;          
            this.coreService.DeleteCoreTransaction(this.deleteCoreModel).subscribe((response) => {
                if (response != undefined) {
                  this.responseHolder = response;
                  this.loaderService.hide();
                  if (this.responseHolder.status == this.statusConst.statusSuccess) {                    
                    this.closeListingDetail(false);
                    this._dataSharingService.sendSaveUserForCore();          
                     this.toastr.success('Record delete successfully.', '', {
                     timeOut: 3000,
                    });
                  }
                } else {
                  this.loaderService.hide();
                }
              });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });    
  }


  
  
  // get Activity List
  getAllTouchesList() {
    var ReqModel={
      folderID:this.folderId,
      transactionID:Number(sessionStorage.getItem('transactionID')),
      documentID:null,
      databaseId:Number(this.databaseId),
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      userID:this.currentUser.UID
    }
     this.coreService.GetAllCoreTouches(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.getTagListResponseHolder = response.data;
          if(this.getTagListResponseHolder !=null){
            this.getTagListResponseHolder.map((res) => {
              if (res.createdByLastName != null) {
                res.createdByFirstName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey,res.createdByFirstName);
              }
              if (res.createdByLastName != null) {
                res.createdByLastName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey,res.createdByLastName);
              }             
              return res;
            });  
          }          
          this.AllCoreTouchesList = this.getTagListResponseHolder;
         
          // if(this.AllCoreTouchesList.length>0){
          //   this.AllCoreTouchesList.forEach(x => {
          //    if(x.startTime!=null && x.touchTime!=null){
          //     var timeStart:any;
          //     var timeEnd :any;
          //     timeStart = new Date(x.startTime);
          //     timeEnd = new Date(x.touchTime);
          
          //     var diff = (timeEnd - timeStart) / 60000; //dividing by seconds and milliseconds
          
          //     var minutes = diff % 60;
          //     var hours = (diff - minutes) / 60;
          //     x.totalTime= hours+":"+minutes;
          //    }else{
          //     x.totalTime=null;
          //    }
           
          //   });   
          // }
          }
         
        else {
          this.AllCoreTouchesList=[];
        }
      }
    });
  }

 // get touch type ==//
 getTouchTypeList() {
   var ReqModel={
   databaseId:Number(this.databaseId),
   organizationID:Number(this.organizationId) }
   this.settingsService.getAllTouchTypeList(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {          
        this.TouchesType = this.getTagListResponseHolder.data;
      }
      else {
        this.TouchesType=[];
      }
    }
  });
}


  
  
  addTouch() {
    const dialogRef = this.dialog.open(AddTouchesComponent, {     
      data: {
        moduleName:ModuleName.Core,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
        this.getAllTouchesList();
      }
    });   
  }
  
  close() {   
    this.dialog.closeAll();
  }

  clearDate(field) {
    return field.fieldValue="";    
  }

}
